module.exports = __webpack_public_path__ + "static/media/fingernail_left_failed.2f83e1b6.svg";